<template>
  <div>
    <ReLinkingItemList
        :items="items"
        heading="calculator.reLinking.popularPairs"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ReLinkingItemList from '@/components/Calculator/ReLinking/ReLinkingItemList.vue';
import UrlGenerator from '@/services/calculatorUrlGenerator';

export default {
  name: 'PopularPairs',
  components: { ReLinkingItemList },
  data () {
    return {
      amounts: [1, 5, 10, 50, 100, 1000],
    };
  },
  computed: {
    ...mapState('calculator', ['selectedCryptoCurrency', 'selectedFiatCurrency']),
    items () {
      return this.amounts.map((fiatAmount) => {
        return {
          link: UrlGenerator.fiatToCryptoWithAmount(
            this.selectedFiatCurrency.code,
            this.selectedCryptoCurrency.code,
            fiatAmount,
            this.$i18n.locale,
          ),
          title: {
            path: 'calculator.pageTitle.fiatToCryptoWithAmount',
            args: {
              fiatAmount,
              cryptoCode: this.selectedCryptoCurrency.code,
              fiatCode: this.selectedFiatCurrency.code,
            },
          },
        };
      });
    },
  },
};
</script>
